import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSpacer: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSpacer"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4H22V6H2V4ZM2 4H22V6H2V4ZM2 4H22V6H2V4ZM2 4H22V6H2V4ZM2 4H22V6H2V4Z" fill="currentColor"/><Path d="M6 11V13H2V11H6Z" fill="currentColor"/><Path d="M14 11V13H10V11H14Z" fill="currentColor"/><Path d="M22 11V13H18V11H22Z" fill="currentColor"/><Path d="M22 18V20H2V18H22Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSpacer;
